module.exports = __webpack_public_path__ + "static/media/johnson&johnson.c4672f28.png";